import { mapData } from '@/utilities/DataMapping';
import { BookingAction, IBookingAction } from '@/model/BookingAction';
import { Utils } from '@/utilities/Utils';
import { BookingActionDirection, BookingActionResult, RedFlagMessageType, ScanMedium, ScanTiming } from '@/model/Enums';

export interface IScanHistoryVM {
    id: string;
    bookingID: number;
    hotelName: string;
    direction: BookingActionDirection;
    result: BookingActionResult;
    redFlagMessageType: RedFlagMessageType;
    redFlagNotified: Date;
    created: Date;
    resolvedComments: string;
    scanMedium: ScanMedium;
    scanTiming: ScanTiming;
    comments: string;

}

export class ScanHistoryVM implements IScanHistoryVM {

    constructor(data?: IScanHistoryVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IScanHistoryVM) {
        mapData(data, {
            root: () => this
        });
    }

    id: string = Utils.emptyGuidValue;
    bookingID: number = 0;
    hotelName: string = "";
    direction: BookingActionDirection = BookingActionDirection.None;
    result: BookingActionResult = BookingActionResult.None;
    redFlagMessageType: RedFlagMessageType = RedFlagMessageType.None;
    redFlagNotified: Date = new Date(Utils.emptyDateValue);
    created: Date = new Date(Utils.emptyDateValue);
    resolvedComments: string = "";
    scanMedium: ScanMedium = ScanMedium.None;
    scanTiming: ScanTiming = ScanTiming.None;
    comments: string = "";

}